<template>
    <div class="mb-4">
        <h3 v-if="BetsReport.Username">Spendenübersicht <img v-if="BetsReport.IsHbMember" src="/hb-icon.png" class="rounded-circle" width="30" height="30"/> <span class="c-blue">{{ BetsReport.Username }}</span></h3>
        <h1 v-else>
            Wettübersicht
        </h1>

        <div v-if="BetsReport.UserPosition > 0">
            Platzierung: <b>{{ BetsReport.UserPosition }}</b> von <b>{{ BetsReport.TotalDonators }}</b>
        </div>
        Insgesamt: <b>{{ formatNumber(BetsReport.AllBetsTotalDonation) }} &euro;</b><br>
        Anzahl Wetten: <b>{{ BetsReport.AllBetsCnt }}</b>
        <div v-if="!BetsReport.IsSingleUserReport">Teilnehmerinnen: <b>{{ BetsReport.TotalDonators }}</b></div>
    </div>

    <span class="text-muted my-2" v-if="hasMultipleBetTypes()">Wettart auswählen</span>

    <div v-if="hasMultipleBetTypes()" class="btn-group w-100 mb-3" role="group"
        aria-label="Basic radio toggle button group">
        <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" value="0"
            v-model="selectedBetType">
        <label class="btn btn-outline-primary" for="btnradio1">Alle ({{ getCntByBetType(0) }})</label>

        <template v-if="hasBetType(1)">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" value="1" autocomplete="off"
                v-model="selectedBetType">
            <label class="btn btn-outline-primary" for="btnradio2">Spieltag ({{ getCntByBetType(1) }})</label>
        </template>

        <template v-if="hasBetType(2)">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio3" value="2" autocomplete="off"
                v-model="selectedBetType">
            <label class="btn btn-outline-primary" for="btnradio3">Saison ({{ getCntByBetType(2) }})</label>
        </template>

        <template v-if="hasBetType(3)">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio4" value="3" autocomplete="off"
                v-model="selectedBetType">
            <label class="btn btn-outline-primary" for="btnradio4">Einzelspiel ({{ getCntByBetType(3) }})</label>
        </template>

        <template v-if="hasBetType(5)">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio6" value="5" autocomplete="off"
                v-model="selectedBetType">
            <label class="btn btn-outline-primary" for="btnradio6">Hot Take ({{ getCntByBetType(5) }})</label>
        </template>

        <template v-if="hasBetType(4)">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio5" value="4" autocomplete="off"
                v-model="selectedBetType">
            <label class="btn btn-outline-primary" for="btnradio5">Aufrundung ({{ getCntByBetType(4) }})</label>
        </template>
    </div>
    <div v-if="!BetsReport.IsSingleUserReport" class="form-check form-switch" style="margin-left:12px;">
        <input class="form-check-input cursor-pointer" type="checkbox" id="flexSwitchCheckChecked"
            v-model="showUserBetDetails" />
        <label class="form-check-label cursor-pointer bold" style="user-select: none;"
            for="flexSwitchCheckChecked">Aufschlüsselung nach wettenden</label>
    </div>
    <div class="form-check form-switch" style="margin-left:12px;">
        <input class="form-check-input cursor-pointer" type="checkbox" id="nullChecked" v-model="hideNullBets" />
        <label class="form-check-label cursor-pointer bold" style="user-select: none;" for="nullChecked">Noch nicht
            eingetretene ausblenden
        </label>
    </div>


    <div v-for="(betsByBetType, index) in BetsReport.ByBetType" :key="index" class="betyByTypeDiv mt-2"
        :data-bettype="betsByBetType.BetTypeId"
        v-show="selectedBetType == 0 || selectedBetType == betsByBetType.BetTypeId">

        <table class="table table-light table-striped table-hover table-borderless">
            <thead>
                <tr class="table-dark">
                    <th>
                        <small>{{ betsByBetType.SummaryByBetType.BetCnt }}x</small>
                        Wettart: {{ betsByBetType.SummaryByBetType.BetTypeStr }}

                    </th>
                    <th style="text-align:end;" class="text-success">
                        {{ formatNumber(betsByBetType.SummaryByBetType.TotalDonation) }}&nbsp;&euro;</th>
                </tr>
                <tr>
                    <th>Wette</th>
                    <th style="text-align:end;">Summe</th>
                </tr>
            </thead>
            <!-- Ein tbody je Spiel (chronologisch), damit die Streifen je Spiel neu beginnen. Wetten ohne
                 Spielbezug bilden einen Abschnitt ohne Kopfzeile. -->
            <tbody v-for="section in betsByBetType.Sections" :key="section.Match ? section.Match.Id : 'no-match'">
                <tr v-if="section.Match && hasVisibleBets(section)" class="match-header">
                    <th colspan="2">{{ formatMatch(section.Match) }}</th>
                </tr>
                <template v-for="(bet, index) in section.Bets" :key="index">
                    <tr v-if="isBetVisible(bet)">
                        <td>
                            <b v-if="!BetsReport.IsSingleUserReport && betsByBetType.BetTypeId !== '4' && betsByBetType.BetTypeId !== '5'">
                                {{ bet.BetCnt }}x
                                </b> 
                                <template v-if="betsByBetType.BetTypeId == '5'">
                                     <template v-if="(bet.Occured === 0)">
                                        <font-awesome-icon icon="circle-xmark" class="text-danger"></font-awesome-icon>
                                     </template>
                                        <template v-else-if="bet.Occured == null">
                                            <font-awesome-icon icon="circle-question" class="text-warning"></font-awesome-icon>
                                            </template>
                                        <template v-else-if="bet.Occured > 0">
                                            <font-awesome-icon icon="check" class="text-success"></font-awesome-icon>
                                            </template>
                               </template>
                               {{ bet.BetName }}
                               <span v-if="BetsReport.IsSingleUserReport && hasLimits(bet)" class="text-muted small">{{ limitsText(bet) }}</span>
                        </td>

                        <td style="text-align:end;">
                            <span v-if="BetsReport.IsSingleUserReport">
                                <b v-if="bet.Occured == null"> 0 </b>
                                <b>{{ bet.Occured }}x</b>
                                {{ formatNumber(bet.BetsByUsers[0].AmountPerOccurence) }}&nbsp;&euro; ≙
                            </span>

                            <span class="text-success bold">{{ formatNumber(bet.TotalBetAmount) }}&nbsp;&euro;</span>
                        </td>
                    </tr>
                    <td v-if="showUserBetDetails && !BetsReport.IsSingleUserReport && isBetVisible(bet)"
                        colspan="2">
                        <table class="table table-hover m-0">
                            <tbody>
                                <tr v-for="(betByUser, index) in bet.BetsByUsers" :key="index">
                                    <td>
                                        <div class="d-flex justify-content-between">
                                            <span>
                                                <a :href="`/user/${betByUser.Slug}`">
                                                    {{ betByUser.Username }}
                                                    <!-- <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" /> -->
                                                </a>
                                                <span v-if="hasLimits(betByUser)" class="text-muted small">{{ limitsText(betByUser) }}</span>
                                            </span>
                                            <span class="text-right float-right" style="text-align: end;">
                                                <template v-if="betsByBetType.BetTypeId !== '4'">
                                                    {{ bet.Occured }}x {{ formatNumber(betByUser.AmountPerOccurence) }}
                                                    &euro; ≙
                                                </template>
                                                <span class="text-success bold">{{
            formatNumber(betByUser.TotalBetAmount) }}
                                                    &euro;</span>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </template>
            </tbody>
        </table>
    </div>

    <!-- {{ BetsReport }}-->
</template>

<script>
import { GetBetsByFilteredData } from '../GetBetsReport';
import { formatMatch } from '../betMatch';

// Geschütztes Leerzeichen: Betrag und Euro-Zeichen dürfen nicht durch einen Umbruch getrennt werden.
const NBSP = String.fromCharCode(160);

export default {
    name: 'AllBets',
    props: {
        model: {
            type: Object,
            required: true,
        },
        usernameSlug: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            selectedBetType: 0,
            showUserBetDetails: false,
            hideNullBets: true
        };
    },
    mounted() {
        this.hideNullBets = !this.BetsReport.IsSingleUserReport;
    },
    computed: {
        BetsReport() {
            let vm = GetBetsByFilteredData(this.model, this.usernameSlug);
            return vm;
        }
    },
    methods: {
        formatMatch,
        isBetVisible(bet) {
            return !this.hideNullBets || bet.Occured > 0;
        },
        // Kopfzeile nur, wenn darunter überhaupt etwas steht (nicht eingetretene können ausgeblendet sein).
        hasVisibleBets(section) {
            return section.Bets.some(bet => this.isBetVisible(bet));
        },
        hasBetType(betTypeId) {
            return this.BetsReport.ByBetType.some(bet => bet.BetTypeId === betTypeId.toString());
        },
        hasMultipleBetTypes() {
            return this.BetsReport.ByBetType.length > 1;
        },
        getCntByBetType(betTypeId) {
            if (betTypeId === 0)
                return this.BetsReport.ByBetType.reduce((total, bet) => {
                    return total + bet.Bets.reduce((sum, b) => sum + b.BetCnt, 0);
                }, 0);
            const bet = this.BetsReport.ByBetType.find(q => q.BetTypeId === betTypeId.toString());
            return bet ? bet.Bets.reduce((sum, b) => sum + b.BetCnt, 0) : 0;
        },
        // Mindest-/Höchstbetrag einer Wette, damit für Teilnehmer nachvollziehbar ist, warum der Betrag
        // gedeckelt ist bzw. eine nicht eingetretene Wette trotzdem einen Betrag hat.
        hasLimits(limits) {
            return limits.FloorAmount != null || limits.CapAmount != null;
        },
        limitsText(limits) {
            const parts = [];
            if (limits.FloorAmount != null) parts.push(`min. ${this.formatNumber(limits.FloorAmount)}${NBSP}€`);
            if (limits.CapAmount != null) parts.push(`max. ${this.formatNumber(limits.CapAmount)}${NBSP}€`);
            return `(${parts.join(' / ')})`;
        },
        formatNumber(num) {
            return num.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
    },
    components: {}
};
</script>

<style scoped>
/* Kopfzeile je Spiel: dezenter Farbstreifen, ohne den Hover-Zoom der übrigen Zeilen. */
.match-header th {
    background: var(--light-blue);
    color: var(--text-primary);
    font-size: 0.9rem;
    font-weight: 600;
    padding: 0.6rem 1rem;
}

.match-header:hover {
    background-color: transparent;
    transform: none;
}
</style>
